/**
 * Service for position update operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import {
  mapUpdatePositionFromTransport,
  mapUpdatePositionToTransport,
} from '../mappers';
import type {
  LC_UpdatePositionOut,
  UpdatePositionRequest,
  UpdatePositionResult,
} from '../types';


export class PositionUpdateService {
  async update(
    positionId: number,
    request: UpdatePositionRequest,
  ): Promise<ApiResponse<UpdatePositionResult>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.POSITION_BY_ID(positionId);
    const payload = mapUpdatePositionToTransport(request);

    const response = await apiClient.put<LC_UpdatePositionOut>(endpoint, payload);

    if (response.success && response.data) {
      return {
        ...response,
        data: mapUpdatePositionFromTransport(response.data),
      };
    }

    return { ...response, data: null };
  }
}

export const positionUpdate = new PositionUpdateService();